let Constants = {
    debounceTime: 800,
};
export default Constants;
